import React from "react";
import AboutUs from "../components/aboutUs";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

function AboutUsPage() {
  return (
    <>
      <Navbar />
      <AboutUs />
      <Footer />
    </>
  );
}

export default AboutUsPage;
